import {ProductType} from '../products/products.enums';
import {DateTime} from 'luxon';

export interface ProductSelectionStrategy {
  id: number;
  name: string;
  productType: ProductType;
  created: DateTime;
  updated?: DateTime;
  usedIn?: number[];
}

export enum ProductSelectionStrategyType {
  ProspectingTopItems = 10,
  VericastStrategy = 1012,
  Retargeting = 2000,
  RetargetingForNativeAds = 2001,
  StorePromotedItemsForFlightControl = 2010,
  SportsTeamUpcomingGame = 2020,
  SportsTeamLastFinishedGame = 2021,
  SportsTeamUpcomingGameExcludingLiveGames = 2022,
  ProductMatching = 2030,
  ByPlacement = 2031,
  ByPlacementForVideoAds = 2032,
  SpecificProducts = 2033,
  ProductsFromDsp = 2034,
  ProductMatchingVideo = 2035,
  ItemPerCategory = 2036,
  ViewedItems = 2037,
  RetargetingForVideoAds = 2101,
}
